const lang = {
  login: [
    {label: 'ログイン', component: ''},
  ],
  temp_register: [
    {label: 'アカウント作成', component: ''},
  ],
  user_information: [
    {label: 'ホーム', component: 'ProjectList'},
    {label: '会員登録', component: ''},
  ],
  contact_us: [
    {label: 'お問い合わせ', component: ''},
  ],
  url_register_invalid: [
    {label: 'エラー', component: ''},
  ],
  notification: [
    {label: 'お知らせ', component: ''},
  ],
  account: [
    {label: 'アカウント', component: ''},
  ],
  cancel_charge_plan: [
    {label: 'ホーム', component: 'ProjectList'},
    {label: 'アカウント', component: ''},
  ],
  reset_password: [
    {label: 'ログイン', component: 'Login'},
    {label: 'パスワード再設定', component: ''},
  ],
  terms_of_service: [
    {label: '利用規約', component: ''},
  ],
  specified_commodity_transaction_law: [
    {label: '特定商品取引法に基づく表記', component: ''},
  ],
  construction_user: [
    {label: 'ホーム', component: 'ProjectList'},
    {label: '案件一覧', component: ''},
    {label: '', component: ''},
  ],
  accept_invite: [
    {label: 'ホーム', component: 'ProjectList'},
    {label: '共同作業', component: ''},
  ],
  project_list: [
    {label: '案件一覧', component: '', active: true},
  ],
  completion_report: [
    {label: 'ホーム', component: 'ProjectList', active: false},
    {label: '案件一覧', component: 'ProjectList', active: true},
    {},
    {label: '完成報告書', component: '', active: true},
  ],
  privacy: [
    {label: '個人情報の取り扱い', component: ''},
  ],
};

export default lang



// WEBPACK FOOTER //
// ./src/lang/ja/breadcrumb.js